import axios from 'axios'

export default {
    namespaced: true,

    state: {
        stepper: 1,
        mealsToPlan: null,
        people:[],
        suggestedCalories: null,
        credentials: [],
        diet: null,
        allergies: [],
        likes: [],
        newPerson: false,
    },

    actions: {
        clearSignupData({commit}){
            commit('updateStepper',1);
            commit('updateMealsToPlan',null);
            commit('updatePeople',[]);
            commit('resetSuggestedCalories');
            commit('clearCredentials');
            commit('updateDiet',null);
            commit('updateAllergies',[]);
            commit('updateLikes',[]);
        },
        updateStepper({commit},value){
            commit('updateStepper',value);
        },
        updateMealsToPlan({commit},value){
            commit('updateMealsToPlan',value);
        },
        addPeople({commit},value){
            commit('addPeople',value);
        },
        updatePeople({commit},value){
            commit('updatePeople',value);
        },
        removePeople({commit},value){
            commit('removePeople',value);
        },
        peopleChangeMade({commit},value){
            commit('suggestedCalories',value);
        },
        resetSuggestedCalories({commit}){
            commit('resetSuggestedCalories');
        },
        updateSuggestedCalories({commit},value) {
            commit('suggestedCalories',value);
        },
        suggestedCalories({commit},value){
            commit('suggestedCalories',value);
        },
        storeCredentials({commit},value){
            commit('storeCredentials',value);
        },
        clearCredentials({commit}){
            commit('clearCredentials');
        },
        createSQLAccount({commit,rootState}) {
            console.log("signup reateSQLAccount action start");
            let url = rootState.data.url;
            commit('createSQLAccount',url);
        },
        updateDiet({commit},value) {
            commit('updateDiet',value);
        },
        updateAllergies({commit},value) {
            commit('updateAllergies',value);
        },
        updateLikes({commit},value) {
            commit('updateLikes',value);
        },
        updateNewPerson({commit},value) {
            commit('updateNewPerson',value);
        }
        
    },

    mutations: {
        updateStepper(state,value){
            state.stepper = value;
        },
        updateMealsToPlan(state,value){
            state.mealsToPlan = value;
        },
        addPeople(state,value){
            state.people.push(value);
        },
        updatePeople(state,value){
            state.people[value[0]] = value[1];
        },
        removePeople(state,value){
            state.people.splice(value,1);
        },
        resetSuggestedCalories(state){
            state.suggestedCalories = null;  
        },
        suggestedCalories(state,value) {
            console.log('-----------------------------');
            console.log('suggestedCalories input:',value);
            console.log('-----------------------------');
  
            let response = null;
            let gender = null;
            let birthYear = null;
            let weight = null;
            let height = null;
            let activityLevel = null;
            let goalWeight = null;
            let goalWeightAdjustment = null;
              
            if (value[1] == 'new'){
                if (value[2].gender == 'Male' | value[2].gender == 'M') {
                    gender = 'M'
                } else if (value[2].gender == 'Female' | value[2].gender == 'F') {
                    gender = 'F'
                }
                birthYear = parseInt(value[2].birthYear);
                weight = parseInt(value[2].weight);
                height = (parseInt(value[2].heightFt) * 12) + parseInt(value[2].heightIn);
                activityLevel = value[2].activityLevel;
                goalWeight = parseInt(value[2].goalWeight);
                goalWeightAdjustment = Math.max(Math.min(((goalWeight - weight)/13)*500,500),-500)               
            } else if (value[1] == 'update'){
                if (state.people[value[0]].gender == 'Male' | state.people[value[0]].gender == 'M') {
                    gender = 'M'
                } else if (state.people[value[0]].gender == 'Female' | state.people[value[0]].gender == 'F') {
                    gender = 'F'
                }
                birthYear = state.people[value[0]].birth_year;
                weight = state.people[value[0]].weight_lb;
                height = (parseInt(state.people[value[0]].height_ft) * 12) + parseInt(state.people[value[0]].height_in);
                activityLevel = state.people[value[0]].activity_level;
                goalWeight = state.people[value[0]].goal_weight;
                goalWeightAdjustment = Math.max(Math.min(((goalWeight - weight)/13)*500,500),-500)
            } else if (value[1] == 'existing'){
                if (value[0].gender == 'Male' | value[0].gender == 'M') {
                    gender = 'M'
                } else if (value[0].gender == 'Female' | value[0].gender == 'F') {
                    gender = 'F'
                }
                birthYear = value[0].birth_year;
                weight = value[0].weight_lb;
                height = (parseInt(value[0].height_ft) * 12) + parseInt(value[0].height_in);
                activityLevel = value[0].activity_level;
                goalWeight = value[0].weight_goal;
                goalWeightAdjustment = Math.max(Math.min(((goalWeight - weight)/13)*500,500),-500)
            }
            
            let age = (new Date().getFullYear() - birthYear);

            // CONSOLE LOGS FOR DEBUGGING
            // console.log('-----------------------------');
            // console.log('gender:', gender);
            // console.log('age:', age);
            // console.log('weight',weight);
            // console.log('height',height);
            // console.log('activityLevel',activityLevel);
            // console.log('goalWeight',goalWeight);
            // console.log('goalWeightAdjustment',goalWeightAdjustment);
            // console.log('-----------------------------');
              
            if(age >= 16){
                if(
                    gender != null &&
                    birthYear != null &&
                    weight != null &&
                    height != null &&
                    activityLevel != null &&
                    goalWeight != null
                ){
                    response = (
                        weight * 4.531393
                        + height * 15.875
                        - age * 4.92
                    );
        
                    if(gender == "F") {
                        response -= 161
                    } else {
                        response += 5}
                  
                    if(activityLevel == 'sedentary') {
                        response *= 1.2
                    } else if (activityLevel == 'light') {
                        response *= 1.375
                    } else if (activityLevel == 'active') {
                        response *= 1.55
                    } else if (activityLevel == 'very active') {
                        response *= 1.725
                    }

                    response += goalWeightAdjustment;
                            
                    response = Math.round(response);
  
                }
            } else if(age == 2) {
                if(gender == 'M') {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1000
                    } else if (activityLevel == 'active') {
                        response = 1000
                    } else if (activityLevel == 'bery active') {
                        response = 1000
                    }
                } else {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1000
                    } else if (activityLevel == 'active') {
                        response = 1000
                    } else if (activityLevel == 'very active') {
                        response = 1000
                    }
                }
        
            } else if (age == 3) {
                if(gender == 'M') {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1000
                    } else if (activityLevel == 'active') {
                        response = 1400
                    } else if (activityLevel == 'very active') {
                        response = 1400
                    }
                } else {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1000
                    } else if (activityLevel == 'active') {
                        response = 1200
                    } else if (activityLevel == 'very active') {
                        response = 1400
                    }
                }
        
            } else if (age == 4) {
                if(gender == 'M') {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1200
                    } else if (activityLevel == 'active') {
                        response = 1400
                    } else if (activityLevel == 'very active') {
                        response = 1600
                    }
                } else {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1200
                    } else if (activityLevel == 'active') {
                        response = 1400
                    } else if (activityLevel == 'very active') {
                        response = 1400
                    }
                }
        
            } else if (age == 5) {
                if(gender == 'M') {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1200
                    } else if (activityLevel == 'active') {
                        response = 1400
                    } else if (activityLevel == 'very active') {
                        response = 1600
                    }
                } else {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1200
                    } else if (activityLevel == 'active') {
                        response = 1400
                    } else if (activityLevel == 'very active') {
                        response = 1600
                    }
                }
        
            } else if (age == 6) {
                if(gender == 'M') {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1400
                    } else if (activityLevel == 'active') {
                        response = 1600
                    } else if (activityLevel == 'very active') {
                        response = 1800
                    }
                } else {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1200
                    } else if (activityLevel == 'active') {
                        response = 1400
                    } else if (activityLevel == 'very active') {
                        response = 1600
                    }
                }
        
            } else if (age == 7) {
                if(gender == 'M') {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1400
                    } else if (activityLevel == 'active') {
                        response = 1600
                    } else if (activityLevel == 'very active') {
                        response = 1800
                    }
                } else {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1200
                    } else if (activityLevel == 'active') {
                        response = 1600
                    } else if (activityLevel == 'very active') {
                        response = 1800
                    }
                }
        
            } else if (age == 8) {
                if(gender == 'M') {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1400
                    } else if (activityLevel == 'active') {
                        response = 1600
                    } else if (activityLevel == 'very active') {
                        response = 2000
                    }
                } else {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1400
                    } else if (activityLevel == 'active') {
                        response = 1600
                    } else if (activityLevel == 'very active') {
                        response = 1800
                    }
                }
        
            } else if (age == 9) {
                if(gender == 'M') {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1600
                    } else if (activityLevel == 'active') {
                        response = 1800
                    } else if (activityLevel == 'very active') {
                        response = 2000
                    }
                } else {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1400
                    } else if (activityLevel == 'active') {
                        response = 1600
                    } else if (activityLevel == 'very active') {
                        response = 1800
                    }
                }
        
            } else if (age == 10) {
                if(gender == 'M') {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1600
                    } else if (activityLevel == 'active') {
                        response = 1800
                    } else if (activityLevel == 'very active') {
                        response = 2200
                    }
                } else {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1400
                    } else if (activityLevel == 'active') {
                        response = 1800
                    } else if (activityLevel == 'very active') {
                        response = 2000
                    }
                }
        
            } else if (age == 11) {
                if(gender == 'M') {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1800
                    } else if (activityLevel == 'active') {
                        response = 2000
                    } else if (activityLevel == 'very active') {
                        response = 2200
                    }
                } else {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1600
                    } else if (activityLevel == 'active') {
                        response = 1800
                    } else if (activityLevel == 'very active') {
                        response = 2000
                    }
                }
        
            } else if (age == 12) {
                if(gender == 'M') {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1800
                    } else if (activityLevel == 'active') {
                        response = 2200
                    } else if (activityLevel == 'very active') {
                        response = 2400
                    }
                } else {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1600
                    } else if (activityLevel == 'active') {
                        response = 2000
                    } else if (activityLevel == 'very active') {
                        response = 2200
                    }
                }
        
            } else if (age == 13) {
                if(gender == 'M') {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 2000
                    } else if (activityLevel == 'active') {
                        response = 2200
                    } else if (activityLevel == 'very active') {
                        response = 2600
                    }
                } else {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1600
                    } else if (activityLevel == 'active') {
                        response = 2000
                    } else if (activityLevel == 'very active') {
                        response = 2200
                    }
                }
        
            } else if (age == 14) {
                if(gender == 'M') {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 2000
                    } else if (activityLevel == 'active') {
                        return 2400
                    } else if (activityLevel == 'very active') {
                        response = 2800
                    }
                } else {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1800
                    } else if (activityLevel == 'active') {
                        response = 2000
                    } else if (activityLevel == 'very active') {
                        response = 2400
                    }
                }
                
            } else if (age == 15) {
                if(gender == 'M') {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 2200
                    } else if (activityLevel == 'active') {
                        response = 2600
                    } else if (activityLevel == 'very active') {
                        response = 3000
                    }
                } else {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1800
                    } else if (activityLevel == 'active') {
                        response = 2000
                    } else if (activityLevel == 'very active') {
                        response = 2400
                    }
                }
            }
              
            if (value[1] == 'update') {
                state.people[value[0]].suggested_calories = response;
            } else if (value[1] == 'new') {
                state.suggestedCalories = response;
            } else if (value[1] == 'existing'){
                console.log(response);
                // rootState.individual[value[0].index].suggested_calories = response;
            }
        },

        storeCredentials(state,value){
            state.credentials = value;
        },

        clearCredentials(state){
            state.credentials = [];
        },

        createSQLAccount(state,url) {
            let peopleList = '';
            for (let i = 0; i < state.people.length; i++){
                peopleList += '['
                peopleList += state.people[i].name
                peopleList += ','
                peopleList += state.people[i].gender
                peopleList += ','
                peopleList += state.people[i].birth_year
                peopleList += ','
                peopleList += state.people[i].weight_lb
                peopleList += ','
                peopleList += state.people[i].height_ft
                peopleList += ','
                peopleList += state.people[i].height_in
                peopleList += ','
                peopleList += state.people[i].activity_level
                peopleList += ','
                peopleList += state.people[i].goal_weight
                peopleList += ','
                peopleList += state.people[i].daily_calorie_target
                peopleList += ','
                peopleList += state.people[i].suggested_calories
            }

            axios({
                method: 'post',
                url: url,
                data: {
                    request:
                        "create_account @email='" + state.credentials[0] + "'"
                        + ", @diet='" + state.diet + "'"
                        + ", @allergy='" + state.allergies + "'"
                        + ", @like='" + state.likes + "'"
                        + ", @mealsToPlan='" + state.mealsToPlan + "'"
                        + ", @people='" + peopleList + "'"
                }
            })
            .then(response => {
                console.log(response);
            })
            .catch(error => {
                console.log(error);
            })
        },

        updateDiet(state,value) {
            state.diet = value;
        },

        updateAllergies(state,value) {
            if (value.includes('none',0) & value != 'none') {
                state.allergies = ['none'];
            } else {
                state.allergies = value;
            }
        },

        updateLikes(state,value) {
            state.likes = value;
        },

        updateNewPerson(state,value) {
            state.newPerson = value;
        },
    },

    getters: {
        stepper(state){
            return state.stepper;
        },
        mealsToPlan(state){
            return state.mealsToPlan;
        },
        people(state){
            return state.people;
        },
        suggestedCalories(state){
            return state.suggestedCalories;
        },
        credentials(state){
            return state.credentials;
        },
        diet(state){
            return state.diet;
        },
        allergies(state){
            return state.allergies;
        },
        likes(state) {
            return state.likes;
        },
        newPerson(state) {
            return state.newPerson;
        }

    }

}
